import React from "react";
import { GridItem } from "@chakra-ui/react";
import { DatePicker, Form, Grid, TextInput } from "components";
import { useCurrentCase, useOrganizationSettings } from "duck";
import { hooks, utils } from "./duck";

const NotesForm: React.FC = () => {
  const examNote = useCurrentCase(
    medicalCase => medicalCase.data.client.patient.examNote
  );
  const { dateFormat } = useOrganizationSettings();

  const update = hooks.useUpdateExamNotes();

  const validation = React.useMemo(() => utils.getValidation(examNote), [
    examNote
  ]);

  return (
    <Form {...validation}>
      <Form.Watcher
        defaultValues={validation.defaultValues}
        onChange={update}
      />
      <Grid>
        <GridItem>
          <TextInput
            name="additionalNotes"
            label="Additional Notes"
            placeholder="Enter details here"
          />
        </GridItem>
        <GridItem>
          <TextInput
            name="vaccines"
            label="Vaccines"
            placeholder="Enter details here"
          />
        </GridItem>
        <GridItem>
          <TextInput
            name="bloodwork"
            label="Bloodwork"
            placeholder="Enter details here"
          />
        </GridItem>
        <GridItem>
          <TextInput
            name="previousSurgery"
            label="Previous Surgery"
            placeholder="Enter details here"
          />
        </GridItem>
        <GridItem>
          <TextInput
            name="allergies"
            label="Allergies"
            placeholder="Enter details here"
          />
        </GridItem>
        <GridItem>
          <TextInput
            name="treatmentPlan"
            label="Treatment Plan"
            placeholder="Enter details here"
          />
        </GridItem>
        <GridItem>
          <DatePicker
            name="lastMealAt"
            label="Date and Time of Last Meal"
            placeholderText="Select Date and Time of Last Meal"
            maxDate={new Date()}
            showTimeSelect
            dateFormat={`${dateFormat}, h:mm aa`}
          />
        </GridItem>
        <GridItem>
          <TextInput
            name="patientPersonalItems"
            label="Patient Personal Items"
            placeholder="Enter details here"
          />
        </GridItem>
      </Grid>
    </Form>
  );
};

export default NotesForm;
